'use client'

import { useState, useEffect } from 'react'
import styles from './PublisherBio.module.scss'
import {
  Tooltip,
  IconButton,
  Avatar,
  Stack,
  Chip
} from '@mui/material'
import { IPublisher } from '@/interfaces/IPublisher'
import Link from 'next/link'
import { titleCase } from '@/modules/stringService'
import LinkIcon from '@mui/icons-material/Link'
import NextImage from 'next/image'
import imageService from '@/modules/imageService'
import cookieService from '@/modules/cookieService'
import ThemeClient from '@/app/v1/ThemeClient'

interface PublisherBioProps {
  publisher?: IPublisher | null
}

function PublisherBio ({ publisher }: PublisherBioProps) {
  const [selectedTheme, setSelectedTheme] = useState('')

  useEffect(() => {
    const storedTheme = cookieService.getCookie('theme')
    setSelectedTheme(storedTheme || 'dark')
  }, [])

  return (
    <ThemeClient theme={selectedTheme}>
      <div className={styles.wrapper}>
        {publisher &&
          <div className={styles.innerWrapper}>
            <div>
              <Link href={`/${publisher.username}/profile`}>
                <Tooltip title={publisher.username}>
                  <IconButton
                    size="medium"
                    sx={{ ml: 2 }}
                    style={{ margin: 0 }}
                  >
                    {publisher.avatar &&
                      <NextImage
                        src={imageService.postImageURL('avatars', publisher.avatar)}
                        alt='Avatar'
                        width={100}
                        height={100}
                        style={{ borderRadius: '50%', border: '1px solid rgba(0, 0, 0, 0.15)' }}
                      />
                    }
                    {!publisher.avatar &&
                      <Avatar sx={{ width: 100, height: 100 }}>
                        {publisher.username ? publisher.username[0].toUpperCase() : '?'}
                      </Avatar>
                    }
                  </IconButton>
                </Tooltip>
              </Link>
            </div>
            <div className={styles.writtenBy}>
              Written by {' '}
              <span className={styles.username}>
                <Link href={`/${publisher.username}/profile`}>@{publisher.username}</Link>
              </span>
              <div className={styles.chipWrapper}>
                <Stack direction="row" spacing={1}>
                  <Chip
                    color="secondary"
                    size='medium'
                    label={`${titleCase(publisher?.background || 'unspecified')}`}
                  />
                </Stack>
              </div>
            </div>
          </div>
        }
        <div>
          {(publisher?.bio || '').split('\n').map((line, i) => {
            if (line === '') {
              return (
                <br key={i} />
              )
            } else {
              return (
                <p key={i} className={styles.paragraph}>
                  {line}
                </p>
              )
            }
          })}
        </div>
        {publisher && publisher.website &&
          <div className={styles.linkWrapper}>
            <LinkIcon className={styles.linkIcon} />
            {publisher && publisher.website &&
              <a href={publisher?.website} target='_blank'>{publisher?.websiteTitle}</a>
            }
          </div>
        }
      </div>
    </ThemeClient>
  )
}

export default PublisherBio
